import {
  createUserWithEmailAndPassword,
  sendPasswordResetEmail,
  signInWithEmailAndPassword,
  signInWithPopup,
  signInWithRedirect,
  signOut,
  updateProfile,
} from 'firebase/auth';
import { auth, googleProvider } from '../firebase';

const signInCustomerWithGoogle = async () => {
  try {
    await signInWithPopup(auth, googleProvider);
  } catch (err) {
    if (err?.code === 'auth/popup-blocked' || err?.code === 'auth/popup-closed-by-user') {
      await signInWithRedirect(auth, googleProvider);
      return;
    }
    throw err;
  }
};

const signInCustomerWithEmail = (email, password) =>
  signInWithEmailAndPassword(auth, email, password);

const registerCustomerWithEmail = async (email, password, name = '') => {
  const credential = await createUserWithEmailAndPassword(auth, email, password);
  const displayName = String(name || '').trim();
  if (displayName) {
    await updateProfile(credential.user, { displayName });
  }
  return credential;
};

const requestCustomerPasswordReset = (email) =>
  sendPasswordResetEmail(auth, email);

const signOutCustomer = () => signOut(auth);

export {
  signInCustomerWithGoogle,
  signInCustomerWithEmail,
  registerCustomerWithEmail,
  requestCustomerPasswordReset,
  signOutCustomer,
};
